import React from 'react';
import { motion } from 'framer-motion';
import { phoneDisplay, address } from '../data/menuData';

const INFO_INITIAL = { opacity: 0, x: 50 };
const INFO_ANIMATE = { opacity: 1, x: 0 };
const INFO_TRANSITION = { duration: 0.6, delay: 0.4 };

export const HeroInfoPanel = ({ t }) => (
  <motion.div
    initial={INFO_INITIAL}
    animate={INFO_ANIMATE}
    transition={INFO_TRANSITION}
    className="rounded-2xl border border-border bg-card p-6 space-y-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-none lg:min-w-[280px]"
  >
    <div className="rounded-xl bg-primary px-4 py-3 text-primary-foreground text-center">
      <div className="text-xs font-bold uppercase tracking-widest">{t.deliveryAvailable}</div>
      <div className="mt-1 text-2xl font-black">{phoneDisplay}</div>
    </div>
    <div className="space-y-2 text-sm">
      <div className="font-bold">{t.address}</div>
      <div className="text-foreground/70">{address}</div>
      <div className="pt-2 font-bold">{t.hours}</div>
      <div className="text-foreground/70">{t.hoursDetail}</div>
      <div className="text-foreground/70">{t.hoursMonSat}</div>
      <div className="text-foreground/70">{t.hoursSun}</div>
    </div>
  </motion.div>
);
